module.exports = __webpack_public_path__ + "static/404-ef49132c2ae7957764019c5e1f910d69.svg";